<template>
    <v-container>
        <div>
            <div style="background-color: rgb(230, 233, 242);">
                <v-img :src="require('../assets/rcp4.png')" max-width="100%" contain>
                    <v-row>
                        <v-col cols="12" md="6" lg="6">
                            <p style="font-size: 2rem; color: rgb(0, 30, 67);padding-left: 20px; margin-top: 20px;">
                                <b>UN Information Laboratory on Crime and Corruption for Latin America and the Caribbean (UN iLabCC)</b>
                            </p>                            
                        </v-col>
                    </v-row> 
                </v-img>
            </div>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-card-text>
                <div>
            <h2>Our Mission</h2>
                    <p>
                        The United Nations Information Laboratory on Crime and Corruption for Latin America and the Caribbean - UN iLabCC is a knowledge hub specially 
                        crafted for sharing well-curated information and resources to enhance the UN system’s work against organized crime and corruption.<br><br>
                        
                        Our mission is to empower UN Resident Coordinators, their offices, and UN Country Teams (UNCTs) to address the critical challenges 
                        of corruption and organized crime - along with other related issues pivotal to 
                        <a href="https://www.un.org/sustainabledevelopment/peace-justice/" target="_blank">SDG 16</a> and associated SDGs - by providing 
                        comprehensive access to a suite of tools and knowledge products, as well as e-learning resources. <br><br>
                        
                        The platform offers key assets for the crafting of evidence-based legal and institutional frameworks, policy advice, and technical 
                        assistance. These services aims to ultimately enhance Member States´s capacities within the region to effectively prevent and tackle 
                        transnational organized crime, corruption, amongst other priority areas.
                    </p>
                </div>
            </v-card-text>
            <v-spacer></v-spacer>
        </div>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                images: [],
                chip: [],
            },
            showPdf: false,
        };  
    },
    methods: {        
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
        openPdf() {
            this.showPdf = true;
        },
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1 {
        font-family: 'Heebo', sans-serif;
        font-size: 14px;        
        line-height: 1.6em;
    }
</style>